import { UserId } from "@goodfill/domain-properties";
import { Fetcher, SafeResponse } from "../../../fetcher";
import { CognitoIdToken } from "../../users/authTypes";
import { CustomerApplicationWizardSave } from "@goodfill/domain-customer-application-types";
import { z } from "zod";

const refreshTokenErrors = [
  z.literal("CustomerApplicationWizardSaveNotFound"),
  z.literal("CustomerApplicationWizardSaveNotFound"),
] as const;

export type ApiFetchCustomerApplicationWizardRequest = { userId: UserId };

export const fetchCustomerApplicationWizard = async (
  fetcher: Fetcher,
  cognitoIdToken: CognitoIdToken,
  request: ApiFetchCustomerApplicationWizardRequest,
): // Todo: replace `CustomerApplicationSubmission` with actual zod validation
Promise<SafeResponse<CustomerApplicationWizardSave, "CustomerApplicationWizardSaveNotFound">> => {
  return fetcher({
    endpoint: `/customer-application/wizard/user/${request.userId}`,
    method: "GET",
    cognitoIdToken,
    errors: refreshTokenErrors,
  });
};
